import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'

const warmupDataSiteConfig: SiteConfigFn<Record<string, never>> = () => {
	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: false,
		siteConfig: null,
	}
}

const name = 'warmupData'

export const config = { site: warmupDataSiteConfig, reactNativeSite: warmupDataSiteConfig, name }
